/* What `@adea/ui`'s blocks and thread view need with no app around them (the site, a PDF, a test): the English words
   and the formats. The app passes its live copy through `BlocksProvider` instead. */
export { createFormat, type Formatter } from "./format.ts";

import blocks from "./copy/blocks.ts";

export const appBlocksEn = blocks.en;
